import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["placeholder", "maxlength", "value"]
const _hoisted_2 = {
  key: 0,
  class: "clear"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-multi-string-tag", [_ctx.readonly && 'readonly', _ctx.disabled && 'disabled']])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (item, index) => {
      return (_openBlock(), _createBlock(_component_a_tag, {
        title: item,
        visible: true,
        closable: !_ctx.readonly,
        key: index
      }, {
        closeIcon: _withCtx(() => [
          _createVNode(_component_CloseOutlined, {
            onClick: ($event: any) => (_ctx.delTag(index))
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item) + " ", 1)
        ]),
        _: 2
      }, 1032, ["title", "closable"]))
    }), 128)),
    _createElementVNode("input", {
      class: _normalizeClass(["input", [_ctx.tags.length === 0 && 'tags-empty', _ctx.readonly && 'readonly', _ctx.disabled && 'disabled']]),
      placeholder: _ctx.tags.length > 0 || _ctx.disabled || _ctx.readonly ? '' : _ctx.placeholder,
      maxlength: _ctx.unitValueLength,
      value: _ctx.current,
      onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.currentChange && _ctx.currentChange(...args)), ["stop"])),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addTag && _ctx.addTag(...args)), ["enter"])),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addTag && _ctx.addTag(...args)))
    }, null, 42, _hoisted_1),
    (_ctx.clearStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_CloseCircleFilled, {
            class: "anticon anticon-close-circle ant-input-clear-icon",
            onClick: _ctx.clearTag
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}